"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./detailInit.request"), exports);
(0, tslib_1.__exportStar)(require("./purchaseInit.request"), exports);
//# sourceMappingURL=index.js.map